import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyImport, LazyBootModule } from 'owa-bundling-light';

export const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "NativeInterop" */ './lazyIndex'),
    { name: 'NativeInterop' }
);

export const lazyStartOutlookNativeHostInterop: LazyAction<
    typeof lazyIndex.startOutlookNativeHostInterop,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.startOutlookNativeHostInterop);

export const lazyLogToConsole: LazyImport<typeof lazyIndex.logToConsole, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.logToConsole);
